export default class NpawPluginOptions {
    constructor() {
        /**
         * Fast Data server host
         * Default: 'lma.npaw.com'
         */
        this.host = 'lma.npaw.com';
        this.components = {};
        this.balancerAnalyticsEnabled = false;
        /**
         * Controls behaviour when an active session expires.
         * - 'auto' (default): plugin transparently creates a new session re-using the last start params.
         * - 'never': plugin drops queued events, fires SESSION_EXPIRE, and waits for the host app to
         *   start a new session explicitly. Useful in environments (e.g. SmartTVs with multitasking
         *   freeze/resume) where automatic recovery races the app and produces ghost sessions.
         */
        this.sessionRecovery = 'auto';
        this.host = 'lma.npaw.com';
        this.components = {};
        this.balancerAnalyticsEnabled = false;
        this.sessionRecovery = 'auto';
    }
}
